import DashboardSettings from 'components/settings/DashboardSettings';

const Settings = () => {
  return <DashboardSettings />;
};

export default Settings;
